import { createContext, useContext } from "react";

import type { TrackingMutationResultV2, TrackingOperation } from "./types";

export type TrackingAvailability =
  | "ready"
  | "offline"
  | "reconnecting"
  | "storage-opening"
  | "storage-blocked"
  | "storage-error"
  | "unavailable";

export interface TrackingRuntimeValue {
  ownerId: string | null;
  availability: TrackingAvailability;
  canMutate: boolean;
  isMutating: boolean;
  mutate: (operation: TrackingOperation) => Promise<TrackingMutationResultV2>;
}

export const unavailableTrackingRuntime: TrackingRuntimeValue = {
  ownerId: null,
  availability: "unavailable",
  canMutate: false,
  isMutating: false,
  mutate: () => Promise.reject(new Error("Tracking requires a connected authenticated backend.")),
};

export const TrackingRuntimeContext = createContext<TrackingRuntimeValue>(
  unavailableTrackingRuntime,
);

export function useTrackingRuntime() {
  return useContext(TrackingRuntimeContext);
}
